import React from 'react';
import {
	createMuiTheme,
	ThemeProvider,
	withStyles,
} from '@material-ui/core/styles';
require('typeface-open-sans');

const Theme = ({ children }) => {
	const styles = children.props.styles;
	const theme = createMuiTheme({
		typography: {
			fontFamily: styles.fonts,
			fontSize: styles.body.fontSize,
		},
		palette: {
			primary: { main: styles.brandPrimary.value },
			secondary: { main: styles.brandSecondary.value },
			textColor: { main: styles.body.color },
			background: { default: styles.body.background },
			text: { primary: styles.body.color },
		},
		overrides: {
			MuiAppBar: {
				colorPrimary: {
					backgroundColor: styles.navbar.background,
					color: styles.navbar.color,
				},
			},
			MuiTypography: {
				body1: { fontSize: styles.body.fontSize },
				body2: { fontSize: '14px' },
				h1: {
					fontFamily: styles.headings.fontFamily,
					fontSize: styles.headings.h1.fontSize,
					lineHeight: styles.headings.h1.lineHeight,
					fontWeight: styles.headings.h1.fontWeight,
					color: styles.headings.h1.color,
				},
				h2: {
					fontFamily: styles.headings.fontFamily,
					fontSize: styles.headings.h2.fontSize,
					lineHeight: styles.headings.h2.lineHeight,
					fontWeight: styles.headings.h2.fontWeight,
					color: styles.headings.h2.color,
				},
				h3: {
					fontFamily: styles.headings.fontFamily,
					fontSize: styles.headings.h3.fontSize,
					lineHeight: styles.headings.h3.lineHeight,
					fontWeight: styles.headings.h3.fontWeight,
					color: styles.headings.h3.color,
				},
				h4: {
					fontFamily: styles.headings.fontFamily,
					fontSize: styles.headings.h4.fontSize,
					lineHeight: styles.headings.h4.lineHeight,
					fontWeight: styles.headings.h4.fontWeight,
					color: styles.headings.h4.color,
				},
				h5: {
					fontFamily: styles.headings.fontFamily,
					fontSize: styles.headings.h5.fontSize,
					lineHeight: styles.headings.h5.lineHeight,
					fontWeight: styles.headings.h5.fontWeight,
					color: styles.headings.h5.color,
					marginBottom: '26px',
				},
				caption: {
					fontSize: '0.7em'
				}
				//h6: { fontFamily: styles.headings.fontFamily, fontSize: styles.headings.h6.fontSize, lineHeight: styles.headings.h6.lineHeight, fontWeight: styles.headings.h6.fontWeight,  color: styles.headings.h6.color },
			},
			MuiButton: {
				containedPrimary: {
					backgroundColor: styles.buttons.primary.background,
					color: styles.buttons.primary.color,
					'&:hover': {
						backgroundColor: styles.buttons.primary.hover.background,
						color: styles.buttons.primary.hover.color,
					},
				},
				containedSecondary: {
					backgroundColor: styles.buttons.secondary.background,
					color: styles.buttons.secondary.color,
					'&:hover': {
						backgroundColor: styles.buttons.secondary.hover.background,
						color: styles.buttons.secondary.hover.color,
					},
				},
				textSecondary: {
					color: styles.buttons.textSecondary.color,
					'&:hover': {
						color: styles.buttons.textSecondary.hover.color,
					},
				},
			},
			MuiInputBase: {
				input: {
					'&::placeholder': {
						color: styles.inputs.placeholder.color,
						opacity: 1,
					},
				},
			}
		},
	});
	const GlobalCSS = withStyles({
		'@global': {
			body: {
				margin: 0,
				padding: 0,
				backgroundColor: styles.body.background,
				color: styles.body.color,
				fontFamily: styles.fonts,
				fontWeight: styles.body.fontWeight,
				lineHeight: styles.body.lineHeight,
			},
			'.successFontColor': { color: styles.successColor },
			a: { color: styles.linkColor },
			'.MuiTypography-h6': { fontWeight: 300 },
			'.MuiButton-root': { textTransform: 'none' },
			'.containerButtonProgressSearch': {
				marginTop: '16px',
				width: '100%',
				'& .buttonSearch': { height: '40px' },
			},
			'.buttonLink': {
				textTransform: 'none',
				fontSize: '13px',
			},
			'.cheaper': {
				backgroundColor: styles.buttons.filterCheaper.background,
				color: styles.buttons.filterCheaper.color,
				border: styles.buttons.filterCheaper.border,
				'&:hover': {
					backgroundColor: styles.buttons.filterCheaper.hover.background,
					color: styles.buttons.filterCheaper.hover.color,
					border: styles.buttons.filterCheaper.hover.border,
					boxShadow: 'none !important',
				},
				'&.active': {
					backgroundColor: styles.buttons.filterCheaper.hover.background,
					color: styles.buttons.filterCheaper.hover.color,
					border: styles.buttons.filterCheaper.hover.border,
					boxShadow: 'none !important',
				},
			},
			'.more-flexible': {
				backgroundColor: styles.buttons.moreFlexible.background,
				color: styles.buttons.moreFlexible.color,
				border: styles.buttons.moreFlexible.border,
				'&:hover': {
					backgroundColor: styles.buttons.moreFlexible.hover.background,
					color: styles.buttons.moreFlexible.hover.color,
					border: styles.buttons.moreFlexible.hover.border,
					boxShadow: 'none !important',
				},
				'&.active': {
					backgroundColor: styles.buttons.moreFlexible.hover.background,
					color: styles.buttons.moreFlexible.hover.color,
					border: styles.buttons.moreFlexible.hover.border,
					boxShadow: 'none !important',
				},
			},
			'.selected': {
				backgroundColor: styles.buttons.primary.background,
				borderColor: styles.buttons.primary.background,
				color: styles.buttons.primary.color,
				'&:hover': {
					backgroundColor: styles.buttons.primary.hover.background,
					color: styles.buttons.primary.hover.color,
				},
			},
			'.MuiButton-text': {
				/* padding: "2px", 
				margin: "-2px 4px" */
				padding: 0,
				margin: 0,
				minWidth: 'inherit',
				'&:hover': {
					textDecoration: 'underline',
					backgroundColor: 'transparent',
				},
			},
			'.containerButtonProgress': {
				'& .wrapperButtonProgress': { position: 'relative', width: '100%' },
				'& .buttonProgress': {
					position: 'absolute',
					top: '50%',
					left: '50%',
					marginTop: -12,
					marginLeft: -12,
					color: 'white',
				},
			},
			'.InputForm': {
				paddingTop: '16px',
				[theme.breakpoints.down('sm')]: {
					marginBottom: '10px',
				},
				'& .MuiInputBase-root': {
					height: '40px',
					fontSize: '14px',
					lineHeight: '1.45',
					background: 'white',
				},
				'& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
					transform: 'none',
					fontSize: '13px',
					'& .info': {
						fontSize: '10px',
					},
				},
				'& .MuiInputLabel-formControl': {
					color: styles.inputs.label.color,
				},
				'& .MuiOutlinedInput-notchedOutline': {
					top: 0,
					'& legend': { display: 'none' },
				},
				'&.edad': { minWidth: '48px' },
				'&.datepicker': {
					minWidth: '70px',
					width: '100%',
					'& .MuiOutlinedInput-adornedEnd': {
						padding: 0,
					},
				},
				'& .MuiOutlinedInput-input': {
					padding: '10.5px 8px',
				},
			},
			'.label-text': {
				transform: 'none',
				fontSize: '13px',
				color: styles.inputs.label.color,
			},
			'.white-content': { padding: '15px', backgroundColor: '#fff' },
			'.MuiCardHeader-root': { background: '#fbfbfb' },
			'.close-menu-button': {
				position: 'absolute',
				right: '0',
				zIndex: '1000',
			},
			'.site_header_toolbar': {
				[theme.breakpoints.down('sm')]: {
					padding: 0,
				},
				'& img': {
					[theme.breakpoints.down('sm')]: {
						maxHeight: '45px',
					},
				},
			},
			'.popper-menu': {
				padding: '0',
				'& .popper-menu-paper': {
					padding: '0',
					[theme.breakpoints.up('md')]: {
						width: '160px',
					},
				},
				'&.popper-menu-contacto': {
					'& .popper-menu-paper': {
						[theme.breakpoints.up('md')]: {
							width: '180px',
						},
					},
				},
			},
			'.navbar-list': {
				[theme.breakpoints.down('sm')]: {
					paddingTop: '45px',
				},
				[theme.breakpoints.up('md')]: {
					display: 'flex',
					marginTop: '25px',
				},
				'& .menu-item': {
					padding: '4px 4px',
					'&.menu-item-contacto': {
						'& .submenu': {
							'& p': {
								fontSize: '12px',
							},
						},
					},
					'&.submenu': {
						//width: '150px',
						whiteSpace: 'break-spaces',
						'& p': {
							width: '100%',
							overflow: 'hidden',
						},
					},
				},
				'& .list_item': {
					[theme.breakpoints.down('sm')]: {
						width: '100%',
					},
				},
				'& .link-menu': {
					textTransform: 'uppercase',
					paddingRight: '18px',
					position: 'relative',
					fontSize: '13px',
					'& .MuiIcon-root': {
						position: 'absolute',
						right: '0',
						fontSize: '16px',
						top: '2px',
					},
				},
				'& .link-submenu': {
					display: 'block',
				},
			},
			'.site-header': {
				'& .navbar-brand': { flex: '1 1 auto' },
			},
			'.search-form-section': {
				//minHeight: "450px",
				minHeight: '55vh',
				position: 'relative',
				margin: '0',
				padding: 0,
				//"& .containerWrapperOpcType": {padding: 0},
				'& .wrapperOpcType': {
					'& .titleOpcType': {
						margin: '0 10px 10px 0',
						fontFamily: 'inherit',
						fontWeight: '500',
						lineHeight: '1.2',
						color: '#002848',
						fontSize: '17px',
					},
				},
				'& .bgMask': {
					position: 'absolute',
					zIndex: '-1',
					top: '0',
					left: '0',
					right: '0',
					margin: 'auto',
					bottom: '0',
					width: '100%',
					//minHeight: "450px",
					minHeight: '55vh',
					backgroundSize: 'cover',
					backgroundPosition: 'center center',
					backgroundImage: styles.backgroundImageHome,
				},
				'& .bgLogin': {
					backgroundImage:
						'url(https://s3.amazonaws.com/sonatatijes3/default/0001/01/766b2c323bf6242b2fb2904c5b11c52d0d94e4b7.jpeg)',
				},
			},
			'.form-search-trains': {
				'& .MuiGrid-spacing-xs-1': {
					width: 'calc(100% + 4px)',
					margin: '-2px',
				},
				'& .MuiGrid-spacing-xs-1 > .MuiGrid-item': {
					padding: '2px',
				},
				'& .cont-controls': {
					marginBottom: '-5px',
					marginTop: '10px',
					display: 'flex'
				},
				'& .tramo': {
					marginBottom: '15px',
					position: 'relative',
					paddingLeft: 40,
					'& .button-delete': {
						top: '15px',
						right: '-50px',
						position: 'absolute',
						zIndex: 10,
					},
				},
				'& .numeroTramo': {
					color: styles.numeroTramo.color,
					border: '1px solid',
					borderColor: styles.numeroTramo.borderColor,
					fontSize: '14px',
					lineHeight: '14px',
					overflow: 'hidden',
					padding: '7px 11px',
					//position: 'relative',
					borderRadius: '50%',
					width: 30,
					height: 30,
					top: 22,
					margin: 'auto',
					position: 'absolute',
					left: 0
				},
				'& .MuiInputAdornment-positionEnd': {
					'& .MuiIconButton-root': {
						position: 'absolute',
						top: '-4px',
						right: '0',
						display: 'block',
					},
				},
				'& .col-passengers': {
					position: 'relative',
					'& .container': {
						[theme.breakpoints.down('sm')]: {
							borderTop: '1px solid rgba(0,0,0,.1)',
							paddingTop: '12px',
						},
					},
					'& .MuiInputBase-root': {
						[theme.breakpoints.down('xs')]: {
							marginTop: 15,
						},
					},

					// '& .col-picker-number' :{
					//     [theme.breakpoints.up('md')]: {
					//         maxWidth: "36%",
					//         flexBasis: "36%"
					//     }
					// },
					// '& .col-edades' :{
					//     [theme.breakpoints.up('md')]: {
					//         maxWidth: "64%",
					//         flexBasis: "64%"
					//     }
					// }
				},
			},
			'.headerSearchModule': {
				marginBottom: 15,
				fontSize: 18,
				'& .tab': {},
				'& .inactive': {
					cursor: 'pointer',
					textDecoration: 'underline',
					opacity: 0.7,
					'&:hover': {
						opacity: 1,
					},
				},
				'& .active': {
					color: '#2678c3',
					fontWeight: 600,
				},
				'& .separator': {
					color: 'rgb(0 126 228)',
				},
				'& .title': {
					marginLeft: '15px !important',
					color: '#2678c3 !important',
				},
			},
			'.form-multibuscador-search-container': {},
			'.formMultibuscador': {
				'& .tabsLinks': {
					listStyle: 'none',
					padding: 0,
					margin: 0,
					[theme.breakpoints.down('sm')]: {
						height: '34px',
					},
					'& .tab': {
						cursor: 'pointer',
						display: 'inline-block',
						fontSize: '16px',
						marginRight: '2px',
						lineHeight: '12px',
						position: 'relative',
						'&.active': {
							'& .tabLink': {
								backgroundColor: styles.navbarTabs.active.background,
								color: styles.navbarTabs.active.color,
							},
						},
						'&:hover': {
							'& .tabLink': {
								backgroundColor: styles.navbarTabs.active.background,
								color: styles.navbarTabs.active.color,
							},
						},
					},
					'& .tabLink': {
						textDecoration: 'none',
						color: styles.navbarTabs.color,
						backgroundColor: styles.navbarTabs.background,
						position: 'relative',
						fontSize: '14px',
						marginRight: '2px',
						display: 'block',
						lineHeight: '18px',
						borderRadius: '12px 12px 0 0',
						[theme.breakpoints.down('sm')]: {
							padding: '10px',
							height: '34px',
							width: '34px',
						},
						[theme.breakpoints.up('md')]: {
							padding: '10px 15px 10px 36px',
						},
					},
					'& .iconModule': {
						display: 'block',
						position: 'absolute',
						top: '12px',
						left: '10px',
						width: '18px',
						color: styles.navbarTabsIcon.color,
						[theme.breakpoints.down('sm')]: {
							top: '10px',
							left: '8px',
						},
					},
					'& .material-icons': {
						fontSize: '16px',
						[theme.breakpoints.down('sm')]: {
							fontSize: '20px',
						},
					},
				},
				'& .tabsContent': {
					backgroundColor: 'rgba(255,255,255,.85)',
					padding: '15px',
					borderTop: '3px solid #fff',
					borderRadius: '0 12px 12px 12px'
				},
			},
			'.footer': {
				fontSize: '13px',
				'& li': { marginBottom: '5px' },
				'& a': { textDecoration: 'none', color: styles.footerBottom.color, },
				'& .footerBottom': {
					backgroundColor: styles.footerBottom.background,
					color: styles.footerBottom.color,
					padding: '25px 0px',
					'& .titleLinks': {
						marginBottom: '15px',
						marginTop: '30px',
						display: 'block',
						fontWeight: '600',
						color: styles.footerBottom.color,
						fontSize: '14px',
					},
				},
				'& .legals': {
					backgroundColor: 'white',
					padding: '5px 0px 25px',
					'& .copyright': {
						marginTop: '25px',
						fontSize: '12px',
						margin: 'auto 0 auto auto',
					},
				},
				'& .media-container': {
					paddingLeft: '50%',
				},
				'& .datos-contacto': {
					fontSize: '16px',
					'& .title': { fontSize: '22px', margin: 0, fontWeight: '400' },
					'& li': { marginBottom: '0px' },
					
				},
				'& .bloq-banderas div': { marginLeft: '5px' },
			},
			'.borderTop': { borderTop: '1px solid #dee2e6 !important' },
			'.subscribe': {
				backgroundColor: styles.brandSecondary.value,
				color: '#fff',
				padding: '20px 0px',
				marginTop: '0',
				textAlign: 'center',
				//"& .MuiOutlinedInput-input":{padding:0},
				'& .InputForm': {
					paddingTop: 0,
				},
				'& label': { visibility: 'hidden' },
				'& .button': {
					marginTop: 0,
					width: '180px',
					[theme.breakpoints.down('sm')]: { marginBottom: '10px' },
				},
				'& .title': {
					marginRight: '15px',
					position: 'relative',
					paddingLeft: '30px',
					[theme.breakpoints.down('sm')]: {
						textAlign: 'center',
						fontSize: '17px',
						marginBottom: '15px',
					},
				},
				'& .icon_title': {
					marginRight: '15px',
					position: 'absolute',
					left: 0,
					top: '6px',
					fontSize: '24px',
				},
			},
			'.results': {
				'& .main_content': {
					//padding: '45px'
					marginTop: '35px',
					marginBottom: '35px',
				},
				'& .result_search_container': {
					'& .form-inverse': {
						backgroundColor: styles.navbarResume.background,
						color: styles.navbarResume.color,
						padding: '5px 15px',
						margin: 0,
					},
					'& .title': {
						color: styles.navbarResume.color,
						marginBottom: '20px',
						marginTop: '20px',
						fontSize: '17px',
					},
					'& .item-search': {
						lineHeight: '1.2',
						display: 'inline-block',
						verticalAlign: 'middle',
						padding: '12px 0 12px 10px',
					},
					'& .label-input': {
						display: 'block',
						textTransform: 'uppercase',
						fontSize: '10px',
						opacity: '.7',
					},
					'& .item-detail': {
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						display: 'inline-block',
						verticalAlign: 'bottom',
						fontSize: '13px',
						maxWidth: '110px',
						color: '#fff',
						lineHeight: '15px',
						letterSpacing: '-.5px',
					},
					'& .btn-modify': {
						marginTop: '10px',
					},
					'& .result_search_form': {
						backgroundColor: 'white',
						padding: '25px 15px',
					},
				},
				'& .MuiTab-wrapper': {
					height: '100%',
				},
				'& .MuiTabs-indicator': {
					top: 0,
					bottom: 'inherit',
					backgroundColor: styles.tabs.borderColor,
				},
				'& .tabSegmentTitle': {
					//borderBottom: "2px solid #dceeff",
					'& .Mui-selected': {
						'& .tab-title-content': {
							'& .line-top': {
								backgroundColor: styles.tabs.active.borderColor,
							},
							'& .inner-content': {
								color: styles.tabs.active.color,
								backgroundColor: styles.tabs.active.background,
								borderTop: styles.tabs.active.borderTop,
							},
							'& .tab-title': {
								'& .title': {
									color: styles.tabs.active.color,
								},
								'& .date': {
									color: styles.tabs.active.color,
								},
								'& .year': {
									color: styles.tabs.active.color,
								},
							},
							'& .icon-tab-title': {
								color: styles.tabs.active.color,
							},
							'& .selected-arrow': {
								color: styles.tabs.active.color,
							},
							'& .nro-tramo-tab': {
								color: styles.tabs.active.borderColor,
							},
							'&.segment-selected': {
								'& .line-top': {
									backgroundColor: styles.tabs.selected.borderColor,
								},
								'& .inner-content': {
									color: styles.tabs.selected.color,
									backgroundColor: styles.tabs.selected.background,
									borderTop: styles.tabs.selected.borderTop,
								},
								/* "& .tab-title":{
									"& .title": {
										color: styles.tabs.selected.color
									},
									"& .date": {
										color: styles.tabs.selected.color
									},
									"& .year": {
										color: styles.tabs.selected.color
									} 
								}, */
								/* "& .icon-tab-title": {
									color: styles.tabs.selected.color
								}, */
								'& .selected-arrow': { display: 'none' },
								'& .selected-ok': {
									color: styles.tabs.selected.color,
									display: 'block',
								},
								'& .nro-tramo-tab': {
									color: styles.tabs.selected.borderColor,
								},
							},
						},
					},
					"& .Mui-disabled": {
						"& .tab-title-content.no-results": {
							"& .message-no-results": {
								textAlign: 'center',
								color: 'black',
								border: '1px solid grey',
								borderRadius: 4
							},
							"& .line-top": {
								backgroundColor: styles.tabs.noResults.borderColor
							},
							"& .inner-content": {
								borderTop: styles.tabs.noResults.borderTop,
								opacity: '0.8'
							},
							"& .tab-title": {
								"& .title": {
									color: styles.tabs.noResults.color
								}
							},
							"& .icon-tab-title": {
								color: styles.tabs.noResults.color
							},
							"& .selected-arrow": {
								color: styles.tabs.noResults.color
							},
							"& .nro-tramo-tab": {
								color: styles.tabs.noResults.color
							},

						},
					}
				},
				'& .segment-selected .selected-ok': {
					color: styles.tabs.selected.color,
					display: 'block !important',
				},
				'& .tramo-header': {
					'& .title': {
						fontSize: '18px',
						margin: '15px 0 20px',
						color: styles.tabs.title
					},
					'& .tramo-nro': {
						padding: '0 6px',
						color: styles.tabs.title,
						border: '2px solid',
						borderColor: styles.tabs.title,
						fontSize: '14px',
						lineHeight: '14px',
						overflow: 'hidden',
						position: 'relative',
						top: '-1px',
						fontWeight: '700',
						borderRadius: '50%',
						marginRight: '5px',
						width: '24px',
						height: '24px',
					},
					'& .btn-tramos': {
						marginLeft: '5px',
					},
				},
				'& .tab-title-content': {
					position: 'relative',
					height: '100%',
					width: '100%',
					marginRight: '3px',
					'& .line-top': {
						backgroundColor: styles.tabs.borderColor,
					},
					'& .inner-content': {
						border: 'none',
						color: styles.tabs.color,
						backgroundColor: styles.tabs.background,
						borderTop: styles.tabs.borderTop,
						borderBottomColor: '#fff',
						padding: '10px 15px 10px 5px',
						overflow: 'hidden',
						textAlign: 'left',
						position: 'relative',
					},
					'& .nav-tabs': { borderBottom: '2px solid #dceeff' },
					'& .tab-title': {
						float: 'left',
						width: 'calc(100% - 51px)',
						'& .title': {
							fontSize: '14px',
							marginBottom: '3px',
							marginTop: 0,
							fontWeight: '700',
							color: styles.tabs.color,
							textAlign: 'left',
						},
						'& .date': {
							color: styles.tabs.color,
							fontSize: '12px',
							lineHeight: '16px',
							textAlign: 'right',
							letterSpacing: '-.5px',
							margin: '0',
							'& .MuiIcon-root': {
								fontSize: '14px',
								lineHeight: '16px',
							},
						},
						'& .year': {
							color: styles.tabs.color,
							[theme.breakpoints.up('md')]: {
								fontSize: '22px',
								fontWeight: '100',
								display: 'block',
								lineHeight: '24px',
							},
						},
					},
					'& .selected-arrow': {
						position: 'absolute',
						top: '5px',
						left: '5px',
						color: styles.tabs.color,
						fontSize: '16px',
						transform: 'rotate(90deg)',
					},
					'& .selected-ok': {
						display: 'none',
						position: 'absolute',
						top: '5px',
						left: '5px',
						color: '#28a745',
						fontSize: '16px',
					},
					'& .nro-tramo-tab': {
						position: 'absolute',
						top: '5px',
						left: '15px',
						color: styles.tabs.title,
						fontSize: '14px',
						fontWeight: 'bold',
					},
					'& .icon-tab-title': {
						color: styles.tabs.color,
						textAlign: 'center',
						float: 'left',
						width: '51px',
						paddingLeft: '24px',
						paddingRight: '15px',
						'& .icon-content': { lineHeight: 0, width: '20px' },
						'& .train': { fontSize: '16px' },
						'& .circle': { fontSize: '5px' },
						'& .place': { fontSize: '16px' },
					},
				},
				'& .label-horarios': {
					backgroundColor: styles.navigationHorarios.background,
					position: 'relative',
					color: '#fff',
					padding: '5px',
					display: 'block',
					textTransform: 'uppercase',
					fontSize: '12px',
					textAlign: 'center',
				},
				'& .row-labels': {
					backgroundColor: '#f3f3f3',
					'& .label-rates': {
						textTransform: 'uppercase',
						fontSize: '12px',
						padding: '5px',
					},
				},
				'& .MuiTab-root': {
					padding: 0,
					borderRadius: '5px 5px 0 0',
					[theme.breakpoints.up('md')]: {
						minWidth: '50%!important',
					},
				},
				'& .ContainerSegment': {
					'& .MuiAppBar-root': {
						boxShadow: 'none',
					},
					'& .MuiTabs-scrollButtons': {
						"&[aria-disabled='false']": {
							background: styles.tabs.borderColor,
							color: styles.tabs.color,
							//borderTop: '2px solid rgba(193, 209, 223, 1)'
						},
						'& .MuiSvgIcon-fontSizeSmall': {
							fontSize: '2.25rem',
						},
					},
				},
				'& .breadcrumbs-leyend': {
					marginBottom: '.5rem',
					'& .leyend': {
						textAlign: 'right',
						padding: '.5rem',
						'& p': {
							fontSize: '11px',
							[theme.breakpoints.down('sm')]: {
								display: 'block',
								textAlign: 'left',
								marginBottom: '10px',
							},
						},
						'& .btn-filter': {
							fontSize: '11px',
							marginLeft: '.5rem',
							lineHeight: '1.5',
							[theme.breakpoints.down('sm')]: {
								marginLeft: '0',
								marginRight: '.5rem',
							},
						},

						'& .view-mode': { fontSize: '16px', padding: '0', margin: '2px 0' },
					},
					'& .breadcrumb': {
						padding: '.8rem',
						'& p': { fontSize: '13px' },
					},
					'& .MuiIcon-root': {
						fontSize: '12px',
						top: '2px',
						position: 'relative',
					},
				},
				'& .content': {
					padding: '5px 10px',
					minHeight: '100%',
				},
				'& .content-horarios': {
					fontSize: '.8rem',
					'& .hora': {
						fontSize: '15px',
						color: '#cdcdcd',
						'& span': {
							fontWeight: '600',
							color: styles.headings.color,
							fontSize: '20px',
						},
					},

					'& .nro-tren': {
						//marginTop: "5px",
						//display: "inline-block",
						//marginLeft: "17px"
					},
					'& .duracion': { marginTop: '8px' },
					'& .img-rentadora': {
						//maxHeight: "24px",
						//width: "80px",
						marginRight: '10px',
						verticalAlign: 'top',
						//display: "inline-block",
						//"& img": { maxHeight: "24px" }
					},

					'& .escala': {
						padding: '0',
						height: 'auto',
						margin: '0',
						marginTop: '5px',
						textDecoration: 'underline',
					},
				},
				'& .row-horarios-tarifas': { borderBottom: '2px solid #cdcdcd' },
				'& .offerButton': {
					//marginBottom: '5px',
					marginRight: '5px',
				},
				'& .card-detail-rate': {
					'& .MuiCardHeader-root': {
						padding: 0,
						'& .MuiCardHeader-title': {
							margin: 0,
						},
					},
					'& .card-content': {
						padding: '8px',
						'& .image': {
							margin: 'auto',
						},
					},
					'& .card-products': {
						'& .card-product': {
							fontSize: '13px',
							lineHeight: '16px',
							marginBottom: '12px',
							'& .nro-tren': {
								lineHeight: '23px',
							},
							'& .modal-escala': {
								textAlign: 'right',
							},
							'& .MuiButton-root.MuiButton-text': {
								fontSize: '13px',
								lineHeight: '16px',
								marginTop: '0px !important',
							},
							'& .MuiTypography-root': {
								fontSize: '13px',
								lineHeight: '16px',
							},
							'& .MuiIcon-root': {
								fontSize: '14px',
								lineHeight: '16px',
							},
							'& .card-header-product': {
								padding: '8px',
								marginBottom: '0',
								backgroundColor: 'rgba(0,0,0,.03)',
								borderBottom: '1px solid rgba(0,0,0,.125)',
								color: styles.boxPrice.priceColor,

								'& .MuiTypography-root': {
									fontSize: '12px',
								},
								'& .avatar-product': {
									backgroundColor: styles.boxPrice.priceColor,
									width: '25px',
									height: '25px',
									'& .MuiIcon-root': {
										fontSize: '16px',
									},
								},
								'& .MuiCardHeader-action': {
									'& .MuiIcon-root': {
										fontSize: '16px',
									},
								},
							},
							'& .dayPassItem': {
								fontWeight: 600,
								color: styles.successColor,
								'& .icon': {
									color: styles.successColor,
								},
							},
							'& ul': {
								marginBottom: '10px',
								marginTop: '10px',
								'& p': {
									paddingLeft: '20px',
									position: 'relative',
									'& .icon': {
										position: 'absolute',
										left: 0,
									},
								},
							},
							'& .card-content-product': {
								paddingBottom: '12px',
							},
						},
					},
					'& .tarifa-head': {
						color: styles.boxPrice.priceColor,
						textAlign: 'center',
						fontWeight: '600',
						marginBottom: '15px',
						'&.inverse': {
							backgroundColor: styles.boxPrice.background,
							padding: '8px 10px 10px',
							color: styles.boxPrice.color,
							marginBottom: '0',
							'& .price-currency': {
								fontSize: '29px',
							},
							'& .price': {
								color: styles.boxPrice.color,
								fontSize: '30px',
								lineHeight: '32px',
								fontWeight: '600',
							},
							'& .title': { color: styles.boxPrice.color },
							'& p': { color: styles.boxPrice.color },
						},
						/* //"@include xs": { paddingLeft: "15px" },
						".text": { 
							//"@include xs": { marginTop: "3px" } 
						} */
					},
					'& .tarifa-detail': {
						'& p': { fontSize: '12px' },
						'& .row-total': {
							'& p': {
								color: styles.boxPrice.priceColor,
								fontWeight: '700',
								fontSize: '14px',
								'& span': {
									fontWeight: 'normal',
									fontSize: '12px',
								},
							},
						},
						'& .row-total-leyend': {
							marginBottom: '15px',
						},
					},
					'& .btnResume': {
						marginBottom: '15px',
					},
					'& .footer-card': {
						textAlign: 'center',
						width: '100%',
					},
				},
			},
			'.btn-clear': {
				backgroundColor: styles.buttons.clear.background,
				color: styles.buttons.clear.color,
				border: styles.buttons.clear.border,
				'&:hover': {
					backgroundColor: styles.buttons.clear.hover.background,
					color: styles.buttons.clear.hover.color,
					border: styles.buttons.clear.hover.border,
					boxShadow: 'none !important',
				},
				'&.active': {
					backgroundColor: styles.buttons.clear.hover.background,
					color: styles.buttons.clear.hover.color,
					border: styles.buttons.clear.hover.border,
					boxShadow: 'none !important',
				},
			},
			'.checkout': {
				'& .InputForm .MuiInputLabel-outlined': {
					fontSize: '13px',
				},
				'& .main_content': {
					marginTop: '45px',
					marginBottom: '45px',
				},
				'& .title': {
					marginTop: '20px',
					marginBottom: '20px',
					fontSize: '22px',
				},
				'& .subtitle': {
					marginBottom: '25px',
				},
				'& .title-alternative': {
					marginBottom: '15px',
					fontSize: '22px',
					color: '#002848',
				},
				'& .pax': { marginBottom: '25px' },
				'& .subtitle_pax': {
					marginBottom: '25px',
					fontSize: '14px',
					fontWeight: '600',
				},
				'& .block-info': {
					marginBottom: '20px',
					marginTop: '15px',
					'& .block-info-container': {
						position: 'relative',
						paddingLeft: '45px',
						backgroundColor: styles.infoColor,
						border: '1px solid',
						borderColor: styles.infoColor,
					},
					'& .block-info-container-title': {
						position: 'relative',
						paddingLeft: '45px',
						'& .col-texto': {
							padding: '15px',
							'& .title-message': {
								margin: 0,
								fontSize: '20px',
								color: styles.body.color,
							},
						},
						'& .col-icono': {
							padding: 0,
							height: '52px',
							'& .MuiIcon-root': {
								position: 'absolute',
								top: 'calc(50% - 12px)',
								margin: 'auto',
								left: '0',
								right: '0',
							},
						},
					},
				},
				'& .info-pasajeros': {
					'& .col-icono': {
						padding: '5px',
						position: 'absolute',
						top: '0',
						left: '0',
						width: '45px',
						height: '45px',
						textAlign: 'center',
						color: 'white',
					},
					'& .col-texto': {
						padding: '10px',
						backgroundColor: 'white',
					},
				},
			},
			'.paper': {
				padding: '16px',
				marginBottom: '25px',
			},
			'.paper-outlined': {
				border: '1px solid #e6e6e6',
			},
			'.info-status-reserva': {
				marginTop: '45px',
				padding: '35px 10%',
				'& .bloq-estados-transaccion': {
					fontSize: '18px',
					maxWidth: '600px',
					margin: 'auto',
				},
			},
			'.card': { marginBottom: '25px' },
			'.heading-color': { color: styles.headings.color },
			'.label-resume': {
				color: styles.iconColor,
				fontSize: '13px',
				'& .icon': {
					position: 'relative',
					top: '2px',
				},
			},
			'.card-detail': {
				color: styles.boxPrice.textColor,
				'& .resume-detail': {
					'& .total-resume': {
						'& p': {
							fontWeight: '600',
							color: styles.boxPrice.priceColor,
						},
					},
					'& .price': {
						fontSize: '27px',
						lineHeight: '20px',
					},
					'& .small': {
						fontSize: '12px',
					},
					'& .currency': {
						fontSize: '18px',
						position: 'relative',
						top: '-3px',
					},
				},
			},
			'.info-box': {
				border: '1px solid #e6e6e6',
				padding: '8px 10px',
				marginTop: '15px',
			},
			'.head-resume': {
				backgroundColor: styles.boxPrice.background,
				color: styles.boxPrice.color,
				padding: '12px 16px',
				'& .MuiCardHeader-avatar': {
					height: '20px',
				},
				'& .head-resume-icon': {
					color: styles.boxPrice.color,
					fontSize: '20px',
				},
				'& .MuiTypography-root': {
					fontSize: '18px',
				},
			},
			'.product-detail': {
				'& .tramo-title': {
					marginBottom: '5px',
					fontWeight: '600',
				},
				'& .icon': {
					//color: styles.iconColor,
					fontSize: '14px',
					color: styles.headings.color,
					opacity: '.5',
				},
				'& .detail-item': {
					color: styles.headings.color,
					fontWeight: '600',
					'& .icon': {
						position: 'relative',
						top: '2px',
						color: styles.headings.color,
						opacity: '.5',
					},
				},
				'& .segment-title': {
					backgroundColor: 'whitesmoke',
					marginBottom: 5,
					padding: 3,
					textAlign: 'center',
					fontWeight: '600',
					color: styles.headings.color,
				},
				'& .hora': {
					fontSize: '20px',
				},
			},
			'.list-elements': {
				marginTop: '15px',
				'& .icon': {
					position: 'relative',
					top: '2px',
					color: styles.headings.color,
					opacity: '.5',
					fontSize: '14px',
				},
			},
			'.sitio-seguro': {
				padding: '10px 15px',
				paddingLeft: '35px',
				paddingBottom: '20px',
				backgroundColor: '#F0F0F0',
				color: '#002848',
				borderTop: '2px solid #e8e8e8',
				position: 'relative',
			},
			'.payment-tabpanel': {
				padding: '16px',
				marginBottom: '15px',
				border: '1px solid #e8e8e8',
			},
			'.error': { color: styles.errorColor, fontSize: '12px' },
			'.MuiAutocomplete-option': {
				padding: '4px 12px!important',
				fontSize: '13px',
				'&:hover': {
					backgroundColor: styles.brandPrimary.value,
					color: 'white',
				},
			},
			'.MuiAutocomplete-groupLabel': {
				color: styles.navbarTabs.color,
				fontSize: '12px',
				lineHeight: '12px',
				padding: '8px 12px!important',
				margin: '0',
			},

			'.MuiAutocomplete-paper': {
				padding: '0',
				fontSize: '12px!important',
			},
			'.container_thankyoupage': {
				'& .title-message': {
					marginBottom: '30px',
					marginTop: '30px',
				},
				'& .inner-content': {
					'& .info-status-reserva': {
						padding: '25px 10%',
						border: '1px solid #e6e6e6',
					},
					'& .bloq-estados-transaccion': {
						'& p': { fontSize: '20px' },
					},
					'& .number': {
						backgroundColor: styles.boxPrice.background,
						color: styles.boxPrice.color,
						padding: '8px 15px 7px',
						textAlign: 'center',
						fontSize: '16px',

						'& p': { fontWeight: 'bold' },
					},
					'& .title': { fontSize: '20px', margin: '8px 0' },
					'& .estado': { padding: '5px 0', fontSize: '20px' },
				},
				'& .num-transaccion': { marginBottom: '15px' },
				'& .estado': {
					textAlign: 'center',
					'& .MuiIcon-root': {
						position: 'relative',
						top: '5px',
					},
					'& .texto': { fontSize: '24px' },
				},
				'& .confirmed': {
					'& .estado': { color: styles.successColor },
					'& .block-info-container-title': {
						backgroundColor: styles.successColor,
						borderColor: styles.successColor,
						'& .col-texto': {
							backgroundColor: styles.successColorLighten,
						},
					},
				},
				'& .rejected': {
					'& .estado': { color: styles.errorColor },
				},
				'& .status-message': {
					marginTop: '15px',
				},
				'& .card_container': {
					//minHeight: '500px'
				},
				'&.error-page': {
					'& .card_container': {
						minHeight: 'inherit',
					},
				},
				'& .product-detail': {
					marginTop: '25px',
				},
			},
			'.page-maxwidth': {
				maxWidth: '1580px',
				margin: 'auto',
				width: '100%',
			},
			'.login': {
				maxWidth: '300px',
			},
			'.login-form': {
				padding: '16px',
				'& .title': {
					color: styles.headings.alternative.color,
					//paddingTop: "15px",
					paddingBottom: '15px',
					textAlign: 'center',
					borderBottom: '2px solid',
					borderColor: styles.headings.alternative.color,
					fontSize: '19px',
				},
				'& .loginform-container': {
					paddingTop: '15px',
					paddingBottom: '15px',
				},
			},
			'.passenger-validation-message': {
				color: styles.errorColor,
				fontSize: '12px',
				lineHeight: '12px',
				marginTop: '10px',
				textAlign: 'center',
			},
			'.passenger-leyend': {
				//color: styles.navbarTabs.color,
				fontSize: '12px',
				lineHeight: '12px',
				textAlign: 'right',
				marginTop: 6,
				position: 'absolute',
				right: 0
			},
			'.disabledInput': {
				opacity: 0.4,
				pointerEvents: 'none',
				'& .InputForm .MuiOutlinedInput-input': {
					color: styles.brandSecondary.value,
				},
			},
			// start Passes Results
			'.headerInfo': {
				color: styles.tabs.active.color,
				'& .infoTravel': {
					fontSize: 16,
					'& .separador': {
						marginRight: 15,
					},
					'& .texto': {
						fontSize: 14,
					},
					'& .material-icons': {
						marginRight: 5,
						verticalAlign: 'middle',
						fontSize: 18,
						'&.okIcon': {
							color: styles.successColor,
						},
					},
				},
				'& .title': {
					marginTop: 10,
					marginBottom: 10,
				},
			},
			'.MuiPopover-paper': {
				maxHeight: 500,
			},
			'.containerHeaderTable': {
				'& .headerPase': {
					display: 'inline-block',
					width: '65%',
					backgroundColor: styles.brandSecondary.value,
					color: 'white',
				},
				'& .headerHorarios': {
					display: 'inline-block',
					width: '35%',
					backgroundColor: '#e0e0e0',
				},
				'& .headerPrecios': {
					color: styles.brandSecondary.value,
				},
				'& .tableHeader': {
					padding: 5,
				},
			},
			'.containerProduct': {
				'&.inpar': {
					backgroundColor: '#f9f9f9',
				},

				'& .columnProductoInfo': {
					display: 'inline-block',
					width: '65%',
					padding: 10,
					'& .imgLogo': {
						maxHeight: 28,
					},
					'& .productTitle': {
						color: styles.brandSecondary.value,
						fontSize: 16,
					},
					'& .productConditions': {
						fontSize: 13,
						'& ul': {
							// listStyleType: "disclosure-closed"
							paddingLeft: '10px',
							listStylePosition: 'inside',
						},
						'& p': {
							margin: '7px 0px',
						},
					},
				},
				'& .columnProductoSelectDays': {
					display: 'inline-block',
					width: '35%',
					padding: 10,
					'& .selectDays': {
						marginTop: 15,
					},
				},
				'& .columnPriceButtons': {
					'& .offerButton': {
						margin: '10px 0px',
						width: '95%',
					},
					'& .offerButton': {
						margin: '10px 0px',
						width: '95%',
					},
				},
			},
			'.selectSearchType': {
				marginBottom: 10,
				marginTop: -10,
				'& .MuiFormControlLabel-label': {
					fontWeight: 'normal',
					color: styles.brandSecondary.value,
					marginLeft: '-5px',
				},
			},
			'.filters-search':{
				'& .MuiFormGroup-root':{
					'& .MuiTypography-root':{
						fontWeight: 'normal',
						color: styles.brandSecondary.value,
					}
				}
			},
			'.cols-datepicker-timeselect':{
				position: 'relative'
			},
			'.search-stations-switcher':{
				position: 'absolute',
				right: -18,
				top: 18,
				padding: 6
			},
			'.selectOptionType': {
				marginBottom: 10,
				marginTop: -10,
				paddingLeft: 110,
				'& .MuiFormLabel-root':{
					position: 'absolute',
					left: 0,
					top: 16,
					//fontWeight: 'bold',
					fontSize: 13
				},
				'& .MuiFormControlLabel-label': {
					fontWeight: 600,
					color: styles.brandSecondary.value,
					marginLeft: '-5px',
				},
			},
			'.title-search':{
				marginRight: 10
			},
			'.MuiListSubheader-sticky': {
				color: styles.navbarTabs.color,
				fontSize: '12px',
				lineHeight: '12px',
				padding: '8px 12px!important',
				margin: '0',
				backgroundColor: 'white',
			},
			'.card-products': {
				'& .card-content-product': {
					'& .passes': {
						'& .textLine': {
							marginBottom: 3,
							'& .resaltado': {
								fontWeight: 600,
							},
						},
					},
				},
			},
			'.containerFlex': {
				display: 'flex',
			},
			// end Passes Results
			'.MuiPaper-root .placeholder-item': {
				display: 'none',
			},
			'.placeholder': {
				color: styles.inputs.placeholder.color,
				position: 'relative',
				top: -2,
				left: -1,
			},
			".timer": { 
                color: styles.timer.color, 
                backgroundColor: styles.timer.background, 
                marginBottom: "20px", 
                position: "relative", 
                padding: "8px", 
                [theme.breakpoints.down('sm')]: { padding: "3px 0!important" },
                "& .icon_left,\n    & .icon_right": { 
                    display: "inline-block", 
                    position: "absolute", 
                    top: "10px", 
                    "& .material-icons": { fontSize: "1.4em !important" },
                    [theme.breakpoints.down('sm')]: { top: "6px" }
                },
                "& .icon_left": { left: "8px", top: "12px", fontSize: 18 },
                "& .icon_right": { right: "8px" },
                "& .info_timer": { 
                    color: styles.timer.color, 
                    padding: "0px 4px", 
                    verticalAlign: 'top' 
                },
                "& .MuiIcon-root": { 
                    [theme.breakpoints.down('sm')]: { fontSize: "1.3rem", lineHeight: "1.3rem" } 
                },
                "& .text": { 
                    verticalAlign: "top", 
                    padding: '0 30px', 
                    display: 'inline-block', 
                    [theme.breakpoints.down('sm')]: { 
                        textAlign: 'center', display: 'block' 
                    } 
                },
                "& .inner-text": { 
                    lineHeight:'22px', 
                    display: "inline-block", 
                    verticalAlign: "top", 
                    marginTop: "6px", 
                    marginRight: "8px",
                    [theme.breakpoints.down('sm')]:{
                        marginTop: "3px"
                    }
                },
                "& .time": { 
                    fontSize:'22px', 
                    display: "inline-block",
                    [theme.breakpoints.down('sm')]: {
                        fontSize: "16px", 
                        marginTop: "2px"
                    }
                },
            },
			'.navigation-horarios':{
				display: 'flex',
				justifyContent: 'space-between',
				backgroundColor: styles.navigationHorarios.background,
				color: styles.navigationHorarios.color,
				alignItems: 'center',
				
				'& .button-prev':{
					color: styles.navigationHorarios.color,
					padding: 4
				},
				'& .button-next':{
					color: styles.navigationHorarios.color,
					padding: 4
				}
			},
			".MuiCheckbox-colorSecondary.Mui-checked":{
				color: styles.checkbox.checked.color
			},
			".MuiSwitch-colorSecondary.Mui-checked":{
				color: styles.checkbox.checked.color
			},
			".MuiRadio-colorSecondary.Mui-checked":{
				color: styles.checkbox.checked.color
			},
			".login-content": {
				position: 'absolute',
				right: 0,
				top: 0,
				padding: 10,
				display: 'flex',
				gap: '4px',
				fontSize: 12,
				"& .MuiIcon-root":{
					fontSize: 16,
					color: styles.brandPrimary.value
				},
				"& .name":{color: styles.brandPrimary.value}
			},
			".linklogout":{
				padding: 6,
				minWidth: 'inherit',
				[theme.breakpoints.down('sm')]: {
					paddingTop: '45px',
				},
				[theme.breakpoints.up('md')]: {
					marginTop: '25px',
				},
				"& .MuiIcon-root": {
					fontSize: 18,
				}
			},
			".buttonMisReservas": {
                backgroundColor: styles.buttons.default.background,
                color: "white",
				[theme.breakpoints.down('sm')]: {
					paddingTop: '45px',
				},
				[theme.breakpoints.up('md')]: {
					marginTop: '25px',
				},
                "&:hover": {
                    backgroundColor: styles.buttons.default.hover.background,
                    textDecoration: "none"
                }
            },
			".wrapper-tamesys":{
				"& .site-header":{display: 'none',},
				"& .footer":{ display: 'none' },
				"& .search-form-section":{ minHeight: '70vh'}
			}
		},
	})(() => null);
	return (
		<ThemeProvider theme={theme}>
			<GlobalCSS />
			{children}
		</ThemeProvider>
	);
};

export default Theme;
